<template>
  <div>
    <div v-if="Object.keys(user).length === 0">加载中...</div>
    <div v-else>
      <el-form ref="form" :model="topic" label-position="top">
        <div class="row">
          <el-form-item
              label="分类"
              prop="category_id"
              :rules="[{ required: true, message: '必填' }]"
              class="col-md-6"
          >
            <el-select
                v-model="topic.category_id"
                placeholder="分类"
                filterable
                :required="true"
            >
              <span v-for="category in structuredCategories" :key="category.id">
                <el-option
                    :label="category.name"
                    :value="category.id"
                    :selected="
                    currentCategoryId === category.id ? 'selected' : ''
                  "
                    :disabled="category.id === 'corona'"
                ></el-option>

                <el-option
                    v-for="subcategory in category.subcategories"
                    :key="subcategory.id"
                    :label="'⌙ ' + subcategory.name"
                    :value="subcategory.id"
                    :selected="
                    currentCategoryId === subcategory.id ? 'selected' : ''
                  "
                >
                  <span
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;⌙&nbsp;{{
                      subcategory.name
                    }}</span
                  >
                </el-option>
              </span>
            </el-select>
          </el-form-item>
          <el-form-item
              label="标题"
              prop="title"
              :rules="[{ required: true, message: '必填' }]"
              class="col-md-6"
          >
            <el-input
                v-model="topic.title"
                placeholder="标题"
                :required="true"
            ></el-input>
          </el-form-item>
        </div>
        <!-------------editor-------------->
        <el-form-item
            prop="body"
            :rules="[{ required: true, message: '必填' }]"
        >
          <vue-editor
              useCustomImageHandler
              @image-added="handleImageAdded"
              v-model="topic.body"
              :editor-options="editorOptions"
              :editor-toolbar="editorToolbar"
              :required="true"
          >
          </vue-editor>

          <div class="section-info tagAdminText">
            如果需要管理员置顶，可以在文字中使用"<a
              href="#"
              @click.prevent="pasteAtAdmin('')"
          >@管理员</a
          >",如 "<a href="#" @click.prevent="pasteAtAdmin('求置顶')"
          >求置顶@管理员</a
          >"
          </div>
        </el-form-item>
        <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
              <!--              <el-button>-->
              展开设置 (🏷标签，📸图片，🙈匿名，📝草稿，📌置顶，💰价格，📍位置)
              <!--              </el-button>-->
            </template>

            <div class="row">
              <div class="col-md-6 order-2 order-md-1">
                <el-form-item label="标签(选填)">
                  <el-select
                      v-model="topic.tags"
                      multiple
                      filterable
                      allow-create
                      default-first-option
                      @change="handleInputConfirm"
                      :multiple-limit="10"
                      placeholder="选择或创建话题相关的标签"
                  >
                    <el-option
                        v-for="item in this.tagSuggestions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="邮编(选填)">
                  <el-input
                      v-model="topic.zipcode"
                      maxlength="9"
                      placeholder="在地图显示（选填）"
                  ></el-input>
                </el-form-item>
                <el-form-item label="价格(小于0不显示价格)">
                  <el-input-number
                      :precision="2"
                      v-model="topic.price"
                      type="number"
                      maxlength="9"
                      placeholder="$（选填）"
                      class="full-width"
                  >
                  </el-input-number>
                </el-form-item>
                <el-form-item label="新旧程度(选填)">
                  <el-select
                      v-model="topic.condition"
                      filterable
                      default-first-option
                  >
                    <el-option
                        v-for="item in this.conditions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="col-md-6 order-1 order-md-2">
                <el-form-item>
                  <el-checkbox
                      v-model="topic.pin"
                      :disabled="user.pin_count < 1 || editTopic.display_order > 0"
                  >
                    📌
                    {{
                      editTopic.display_order > 0 ? "已置顶" : "置顶24小时"
                    }}（置顶余额：{{ user.pin_count }}）
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content="每发布一个超过24小时的话题，您将获得0.5个置顶"
                    >
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </el-checkbox>
                </el-form-item>
                <el-form-item>

                  <el-checkbox v-model="topic.save_only">
                    📝
                    {{ this.topic.id == "" ? "存草稿/暂不发布" : "取消发布" }}
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content='存入"我的话题>话题草稿"'
                    >
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </el-checkbox>
                </el-form-item>

                <el-form-item>
                  <el-checkbox
                      :disabled="!user.subscribed"
                      v-model="topic.anonymous">
                    🙈
                    匿名发布
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content='匿名发布后只有在"我的话题"中才能被删除或修改（会员专享）'
                    >
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </el-checkbox>
                </el-form-item>
                <el-form-item>
                  <el-checkbox v-if="this.topic.id != ''" v-model="topic.closed">
                    📁 关闭/存档
                    <el-tooltip
                        class="item"
                        effect="dark"
                        content='存入"我的话题>已关闭话题", 话题不会被搜索到，不影响公开属性或置顶奖励。'
                    >
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </el-checkbox>
                </el-form-item>

                <br/>
                <el-form-item>
                  <el-upload
                      :action="actionUrl"
                      list-type="picture"
                      :headers="{ Authorization: 'Bearer ' + token }"
                      :data="{ type: 'topic' }"
                      name="image"
                      :file-list="initialImages"
                      :limit="20"
                      :multiple="true"
                      :on-preview="handlePictureCardPreview"
                      :on-remove="handleRemove"
                      :on-success="handleUploadSuccess"
                      :before-upload="beforeUpload"
                  >
                    <el-button round icon="el-icon-plus">上传图片</el-button>
                    <div class="section-info" slot="tip">
                      单选或多选，最多20张，最大50M，图片格式：JEPG、JPG、PNG
                    </div>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img
                        width="100%"
                        loading="lazy"
                        title="话题图片"
                        :src="dialogImageUrl"
                        alt="图片"
                    />
                  </el-dialog>
                </el-form-item>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <br/>
        <div style="text-align:center; clear: both" class="">
          <el-button
              native-type="button"
              class="btn-primary"
              @click="postTopic"
              icon="el-icon-check"
          >
            <span v-if="this.topic.id != ''">
              更新此话题
            </span>
            <span v-else>
              创建新话题
            </span>
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations} from "vuex";

export default {
  props: {
    editTopic: {
      default: function () {
        return {
          id: "",
          title: "",
          body: "",
          category_id: "",
          published: true,
          closed: false,
          zipcode: "",
          price: -1,
          condition: "",
          tags: [],
          display_order: 0,
          images: "[]"
        };
      }
    }
  },
  computed: {
    ...mapState(["currentCategoryId", "user", "token", "structuredCategories"]),
    actionUrl: function () {
      return process.env.VUE_APP_API_BASE_URL + "/images/";
    }
  },
  data: function () {
    return {
      //'new', 'used-like-new', 'used-good', 'used-fair'
      conditions: [
        {
          value: null,
          label: "不适用"
        },
        {
          value: "new",
          label: "全新"
        },
        {
          value: "used-like-new",
          label: "九成新"
        },
        {
          value: "used-good",
          label: "七八成新"
        },
        {
          value: "used-fair",
          label: "五六成新"
        }
      ],
      editorOptions: {
        modules: {
          imageResize: {}
        }
      },
      editorToolbar: [
        ["bold", "italic", "underline", "strike"],
        [
          {align: ""},
          {align: "center"},
          {align: "right"},
          {align: "justify"}
        ],
        ["blockquote", "code-block"],
        [{header: [false, 1, 2, 3, 4, 5, 6]}],
        [{list: "ordered"}, {list: "bullet"}],
        [({indent: "-1"}, {indent: "+1"})],
        [{color: []}, {background: []}],
        ["link", "image"],
        ["clean"]
      ],
      topic: {
        id: this.editTopic.id,
        anonymous: this.editTopic && this.editTopic.user && this.editTopic.user.id === 0,
        title: this.editTopic.title,
        body: this.editTopic.body,
        category_id: this.editTopic.category_id,
        save_only: !this.editTopic.published,
        pin: this.editTopic.display_order > 0,
        zipcode: this.editTopic.zipcode,
        closed: this.editTopic.closed,
        price: this.editTopic.price,
        condition: this.editTopic.condition,
        tags: this.editTopic.tags.map(tag => tag.name)
      },
      images: this.editTopic.images ? JSON.parse(this.editTopic.images) : [],
      //tag related
      tagSuggestions: [],
      labelWidth: "20%",
      dialogImageUrl: "",
      dialogVisible: false,
      initialImages: this.editTopic.images
          ? JSON.parse(this.editTopic.images)
          : [],
      showUploads: false
    };
  },
  methods: {
    ...mapMutations(["setLoading"]),
    pasteAtAdmin: function (prefix) {
      this.topic.body +=
          "<span style='background-color: rgba(150,255,150, 0.5); font-size: 12px;'>" +
          prefix +
          "@管理员</span><br />";
    },
    postTopic: function () {
      this.$refs["form"].validate(valid => {
        var self = this;
        if (valid) {
          this.setLoading(true);
          self.topic.images = JSON.stringify(self.images);
          if (self.topic.id) {
            this.deleteRemovedImages();
            this.$http
                .patch("/topics/" + self.topic.id, self.topic)
                .then(response => {
                  //this.editTopic = response.data;
                  self.$emit("confirm:editTopic", response.data);
                  self.$message({
                    message: "话题更新成功",
                    type: "success"
                  });
                  if (!this.topic.display_order && response.data.display_order) {
                    this.user.pin_count--;
                  }
                  this.$emit("close");
                  self.setLoading(false);
                })
                .catch(function (err) {
                  self.setLoading(false);
                  self.$message({
                    showClose: true,
                    type: "error",
                    message: err.response.data && err.response.data.message ? err.response.data.message : err.response.data
                  });
                });
          } else {
            this.$http
                .post("/topics/", self.topic)
                .then(response => {
                  //self.topic = response.data;
                  self.setLoading(false);
                  var newTopicUrl = "/topics/" + response.data.id;
                  var message =
                      "<p>话题创建成功，<a href=" +
                      '"' +
                      newTopicUrl +
                      '"' +
                      ">前往话题</a></p>";
                  self.$message({
                    dangerouslyUseHTMLString: true,
                    message: message,
                    type: "success",
                    duration: "9000"
                  });
                  if (response.data.display_order) {
                    this.user.pin_count--;
                  }
                  this.$emit("close");
                })
                .catch(function (err) {
                  self.$message({
                    showClose: true,
                    type: "error",
                    message: err.response.data && err.response.data.message ? err.response.data.message : err.response.data
                  });
                  self.setLoading(false);
                });
          }
        } else {
          self.setLoading(false);
          return false;
        }
      });
    },
    //tag related ----------------
    handleInputConfirm() {
      var letterNumber = /^[0-9a-zA-Z\u4e00-\u9eff_]{1,20}$/;
      for (var i = 0; i < this.topic.tags.length; i++) {
        this.topic.tags[i] = this.topic.tags[i].trim();
        if (!this.topic.tags[i].match(letterNumber)) {
          this.$message({
            message:
                this.topic.tags[i] +
                ":标签只允许汉字,英文,数字,下划线。字符在10个以内",
            type: "error"
          });
          this.topic.tags.splice(i, 1);
          return;
        }
      }
    },
    // ----------------------
    fetchGlobalTags() {
      if (!this.topic.category_id) {
        this.$axios.get("/tags").then(
            response =>
                (this.tagSuggestions = response.data.map(
                    tag =>
                        new Object({
                          value: tag.name,
                          count: tag.count
                        })
                ))
        );
      } else {
        this.getTagSuggestionsForCategory(this.topic.category_id);
      }
    },
    // wysiwyg related
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      // An example of using FormData
      // NOTE: Your key could be different such as:
      // formData.append('file', file)

      var formData = new FormData();
      formData.append("image", file);
      formData.append("type", "topic");
      this.$http({
        url: "/images",
        method: "POST",
        data: formData
      }).then(response => {
        let url = response.data.path; // Get url from response
        Editor.insertEmbed(cursorLocation, "image", url);
        resetUploader();
      });
    },
    getTagSuggestionsForCategory(categoryId) {
      if (categoryId) {
        this.$axios.get(`/categories/${categoryId}/tags`).then(
            response =>
                (this.tagSuggestions = response.data.map(
                    tag =>
                        new Object({
                          value: tag.name,
                          count: tag.count
                        })
                ))
        );
      }
    },
    handleRemove(file, fileList) {
      // var path = file.url;
      if (file.url.startsWith("blob")) {
        var path = file.response.path;
        if (path != undefined) {
          this.removeImage(path);
        }
      }
      this.syncFiles(fileList);
    },
    removeImage(path) {
      this.$http({
        url: "/images",
        method: "DELETE",
        data: {image: path}
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleUploadSuccess(res, file, fileList) {
      this.syncFiles(fileList);
      //this.topic.images.push({url:res.path});
    },
    syncFiles(fileList) {
      var images = fileList.map(function (eachFile) {
        var path = eachFile.url;
        if (eachFile.url.startsWith("blob")) {
          path = eachFile.response.path;
        }
        return {
          url: path
        };
      });

      this.images = images;
    },
    beforeUpload(file) {
      var mimes = ["image/png", "image/jpeg", "image/gif", "image/jpg"];
      const isValid = mimes.includes(file.type);
      const isLt50M = file.size / 1024 / 1024 < 50;

      if (!isValid) {
        this.$message({
          showClose: true,
          type: "error",
          message: "图片只能是以下格式：JPG、JPEG、PNG!"
        });
      }
      if (!isLt50M) {
        this.$message({
          showClose: true,
          type: "error",
          message: "图片最大为50MB!"
        });
      }
      return isValid && isLt50M;
    },
    deleteRemovedImages() {
      var self = this;
      if (this.images !== undefined) {
        this.initialImages.forEach(function (oldImage) {
          var removed = true;
          if (self.images !== undefined) {
            for (var index = 0; index < self.images.length; index++) {
              if (self.images[index].url == oldImage.url) {
                removed = false;
                break;
              }
            }
          }
          if (removed) {
            self.removeImage(oldImage.url);
          }
        });
      }
    }
  },
  mounted: function () {
    if (this.topic.category_id) {
      this.getTagSuggestionsForCategory(this.topic.category_id);
    } else {
      if (this.currentCategoryId) {
        this.topic.category_id = this.currentCategoryId;
      }
    }
  },
  watch: {
    "topic.category_id": function (newVal) {
      this.getTagSuggestionsForCategory(newVal);
    },
    currentCategoryId: function (newVal) {
      if (newVal !== "corona") {
        this.topic.category_id = this.editTopic.category_id
            ? this.editTopic.category_id
            : newVal;
      }
    }
  }
};
</script>
<style>
.tag-autocomplete li {
  line-height: normal;
  padding: 7px;
}

.tag-autocomplete .value {
  text-overflow: ellipsis;
  overflow: hidden;
}

.section-info {
  margin-top: 10px;
  font-size: 10px;
  color: var(--color-fg-muted);
}

.tagAdminText {
  margin-bottom: 5px;
  right: 3px;
}
</style>
